// Fixed application routes, never a server-provided arbitrary URL. Routing is not authorization.
const codeRoutes = {
  HRM: "/modules/hr",
  MAILBOX: "/modules/mailbox",
  PQC: "/purchase/comparisons",
};
const typeRoutes = {
  module_hr: "/modules/hr",
  module_mailbox: "/modules/mailbox",
  quotation_comparison: "/purchase/comparisons",
};

export function getModuleRoute(menu) {
  const code = String(menu?.menu_code || menu?.code || "").toUpperCase();
  const type = String(menu?.type || "").toLowerCase();
  if (Object.prototype.hasOwnProperty.call(codeRoutes, code)) return codeRoutes[code];
  return Object.prototype.hasOwnProperty.call(typeRoutes, type) ? typeRoutes[type] : null;
}

export function getModuleParentRoute(parent) {
  const children = parent?.child_menu;
  // A mixed legacy parent must retain its existing tab and all unrelated items.
  if (!Array.isArray(children) || !children.length || children.some((child) => !getModuleRoute(child))) return null;
  const roots = new Set(children.map((child) => getModuleRoute(child).split("/").slice(0, 3).join("/")));
  if (roots.size !== 1) return null;
  const visible = children.filter((child) => String(child.status).toLowerCase() === "active" && child.rights?.can_view === true);
  return visible.length ? getModuleRoute(visible[0]) : null;
}

export function visibleModuleMenus(parents) {
  if (!Array.isArray(parents)) return [];
  return parents.filter((parent) => String(parent.status).toLowerCase() === "active")
    .flatMap((parent) => (parent.child_menu || []).filter((child) => String(child.status).toLowerCase() === "active" && child.rights?.can_view === true && getModuleRoute(child)));
}